import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import type { AxiosResponse } from 'axios';

import { axiosInstance } from '@shared/lib/axios';
import type { TUser } from '@entities/user/lib/types';
import type { TAxiosError } from '@shared/lib/types';
import { QUERIES_INFO } from '@shared/lib/const';

export type TGetCurrentUserMappedData = AxiosResponse<TUser>;

export const useGetCurrentUser = (options?: UseQueryOptions<TGetCurrentUserMappedData, TAxiosError, TUser>) =>
  useQuery<TGetCurrentUserMappedData, TAxiosError, TUser>(
    [QUERIES_INFO.currentUser.key],
    () =>
      axiosInstance.get(QUERIES_INFO.currentUser.endpoint).then((response): TGetCurrentUserMappedData => response.data),
    options,
  );
